export default __webpack_public_path__ + "static/media/srilan.d7a3637f.jpg";